import { submitStopBroadcast } from "../../../api/broadcast/broadcastStop.service";
import { SUBMIT_STOP_BROADCAST } from "../actionTypes";

const request = () => ({ type: SUBMIT_STOP_BROADCAST.REQUEST });
const failure = (error) => ({ type: SUBMIT_STOP_BROADCAST.FAILURE, error });
const success = () => ({ type: SUBMIT_STOP_BROADCAST.SUCCESS });

export const SubmitstopBroadcast = (payload,id) => {
  return (dispatch, getState) => {
    dispatch(request());
    return submitStopBroadcast(payload,id)
      .then((res) => {
        dispatch(success(res));
        return Promise.resolve({res:res,status:true});

      })
      .catch((error) => {
        dispatch(failure(error?.message));
        return Promise.resolve({error:error?.message,status:false});
      });
  };
};